import { mutator } from './mutator';

export type ListingContactPayload = {
    listingId: string;
    name: string;
    email: string;
    phone?: string;
    message: string;
    turnstileToken: string;
};

export const sendListingContactEmail = (payload: ListingContactPayload) =>
    mutator<{ ok: boolean }>(
        { url: '/api/v1/portal/listings/contact', method: 'POST', data: payload },
        { portalApiKey: true },
    );
